import { StatusCircle, StatusProps } from "./style";

export const StatusIndicator = ({ status }: StatusProps) => {
  return <StatusCircle status={status || 'desligado'} data-tooltip={status} />;
};